import React from 'react';

import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';

import notify from 'devextreme/ui/notify';
import Button from 'devextreme-react/button';

import CoreUtils from '../../common/utils/CoreUtils';

import DataModelView from '../../common/view/DataModelView';

import './ManageColumnDefaultsPopup.css';

export default class ManageColumnDefaultsPopup extends DataModelView {
	getIntegratedPropertyNames() {
		return [
			'popupSessionId',
			'popupTitle',
			'popupVisible',
			'counterpartyName',
			'columnSettings'
		];
	}

	render() {
		return <Popup
			visible={this.state.popupVisible}
			title={this.state.popupTitle}
			showTitle={true}
			showCloseButton={false}
			hideOnOutsideClick={true}
			width="460px"
			height="auto"
		>
			<Position
				at="middle"
				my="center"
				collision="fit"
			/>
			{this.renderMainContent()}
			<ToolbarItem
				widget="dxButton"
				toolbar="bottom"
				location="after"
				options={{
					icon: 'close',
					text: 'Close',
					onClick: this.props.onCancel,
				}}
			/>
		</Popup>
	}

	renderMainContent() {
		return <>
			<div className="pwx-popup-section-header">
				Changes made here apply only to the <strong>{this.state.counterpartyName}</strong> counterparty.
			</div>
			<div className="pwx-header-spacer" />
			<div>
				<table><tbody>
					<tr>
						<td className="pwx-button-container">
							<Button
								text="Set Defaults"
								type="default"
								onClick={this.onSetDefaultPreferences.bind(this)}
							/>
						</td>
						<td className="pwx-button-spacer"></td>
						<td>
							Use the current column settings as defaults for new users.
						</td>
					</tr>
					<tr>
						<td className="pwx-button-vertical-spacer" />
					</tr>
					<tr>
						<td className="pwx-button-container">
							<Button
								text="Clear Defaults"
								type="default"
								onClick={this.onClearDefaultPreferences.bind(this)}
							/>
						</td>
						<td className="pwx-button-spacer"></td>
						<td>
							Clear the default column settings for new users.
						</td>
					</tr>
					<tr>
						<td className="pwx-button-vertical-spacer" />
					</tr>
					<tr>
						<td className="pwx-button-container">
							<Button
								text="Reset All"
								type="danger"
								onClick={this.onResetAllColumnPreferences.bind(this)}
							/>
						</td>
						<td className="pwx-button-spacer"></td>
						<td>
							Reset <i>all users</i> to use the default column settings on next login.
						</td>
					</tr>
				</tbody></table>
			</div>
		</>;
	}

	safeBindHandlerMethod(handler, callback) {
		return CoreUtils.isDefinedAndNotNull(handler)
			? handler.bind(this, callback)
			: undefined;
	}

	onSetDefaultPreferences() {
		if (CoreUtils.isUndefinedOrNull(this.state.columnSettings))
			return;

		this.state.columnSettings.setDefaultPreferences(this.onSetDefaultPreferencesComplete.bind(this));
	}

	onClearDefaultPreferences() {
		if (CoreUtils.isUndefinedOrNull(this.state.columnSettings))
			return;

		this.state.columnSettings.clearDefaultPreferences(this.onClearDefaultPreferencesComplete.bind(this));
	}

	onResetAllColumnPreferences() {
		if (CoreUtils.isUndefinedOrNull(this.state.columnSettings))
			return;

		this.state.columnSettings.resetAllColumnPreferences(this.onResetAllColumnPreferencesComplete.bind(this))
	}

	onSetDefaultPreferencesComplete(response) {
		if (response.status === 200)
			notify('Default Column Preferences successfully set.', 'success', 3000);
		else
			notify('Default Column Preferences failed to set.', 'error', 3000);
	}

	onClearDefaultPreferencesComplete(response) {
		if (response.status === 200)
			notify('Default Column Preferences successfully cleared.', 'success', 3000);
		else
			notify('Default Column Preferences failed to clear.', 'error', 3000);
	}

	onResetAllColumnPreferencesComplete(response) {
		if (response.status === 200)
			notify('Column Preferences successfully cleared for all users.', 'success', 3000);
		else
			notify('Column Preferences failed to clear for all users.', 'error', 3000);
	}
}